export default function IconPickup(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="256px"
      height="256px"
      viewBox="0 0 24 24"
      fill="#1C2033"
      x="128"
      y="128"
      role="img"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#1C2033">
        <path
          fill="currentColor"
          d="M7.5 2h14v9.5h-2V4h-2v5.618l-3-1.5l-3 1.5V4h-2v5.5h-2V2Zm6 2v2.382l1-.5l1 .5V4h-2Zm-5.065 9.25a1.25 1.25 0 0 0-.885.364l-2.05 2.05V19.5h5.627l5.803-1.45l3.532-1.508a.555.555 0 0 0-.416-1.022l-.02.005L13.614 17H10v-2h3.125a.875.875 0 1 0 0-1.75h-4.69Zm7.552 1.152l3.552-.817a2.56 2.56 0 0 1 3.211 2.47a2.557 2.557 0 0 1-1.414 2.287l-.027.014l-3.74 1.595l-6.196 1.549H0v-7.25h4.086l2.052-2.052a3.25 3.25 0 0 1 2.3-.948h.002h-.002h4.687a2.875 2.875 0 0 1 2.862 3.152ZM3.5 16.25H2v3.25h1.5v-3.25Z"
        />
      </g>
    </svg>
  )
}
